module.exports = __webpack_public_path__ + "img/remove_icon_2.e101715c.webp";